import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

const fetchTags = (reportId, reportType, reportState) => ({
  type: TAGS_REQUEST_ASYNC.INITIATE,
  payload: { reportId, reportType, reportState },
})
const fetchTagsCancel = () => ({ type: TAGS_REQUEST_ASYNC.CANCEL })
export const fetchTagsSuccess = (data, reportId, reportType) => ({
  type: TAGS_REQUEST_ASYNC.SUCCESS,
  payload: { data, reportId, reportType },
})
export const fetchTagsError = (error) => ({
  type: TAGS_REQUEST_ASYNC.ERROR,
  error,
})

const editTags = (reportId, reportType, type, tagsArr) => ({
  type: EDIT_TAGS_REQUEST_ASYNC.INITIATE,
  payload: {
    reportId,
    reportType,
    type,
    tagsArr,
  },
})
export const editTagsSuccess = (data, reportId) => ({
  type: EDIT_TAGS_REQUEST_ASYNC.SUCCESS,
  payload: { data, reportId },
})
export const editTagsError = (error) => ({
  type: EDIT_TAGS_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  fetchTags,
  fetchTagsCancel,
  editTags,
}
